(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beauty-advisor"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const textNode = (tag, text, className) => { const node=document.createElement(tag); node.textContent=text; if(className) node.className=className; return node; };
    const unique = (values, limit) => [...new Map(values.filter((value)=>typeof value==='string' && value.trim()).map((value)=>[value.trim().toLocaleLowerCase(),value.trim()])).values()].slice(0,limit);
    const comparisonSize = (product) => {
      const variant = typeof product.variantTitle === 'string' ? product.variantTitle.trim() : '';
      if (variant && !/^default title$/i.test(variant)) return variant;
      const sizes = typeof product.title === 'string' ? product.title.match(/\b(?:\d+\s*[x×]\s*)?\d+(?:[.,]\d+)?\s*(?:fl\.?\s*oz|ml|cl|l|mg|kg|g|oz)\b/gi) : null;
      return sizes?.length === 1 ? sizes[0].replace(/\s+/g, ' ').trim() : null;
    };
    const copy = (value) => JSON.parse(JSON.stringify(value));
    const bag={busy:false,current:null,phase:'',unknown:false,added:new Set(),present:new Set(),blocked:new Set(),notify:new Set()};
    const variantKey=(value)=>{
      if(typeof value==='number' && !Number.isSafeInteger(value)) return null;
      return String(value || '').match(/^(?:gid:\/\/shopify\/ProductVariant\/)?([1-9]\d{0,19})$/)?.[1] || null;
    };
    const measurementAllowed=()=>{
      try{const privacy=window.Shopify?.customerPrivacy;return privacy?.analyticsProcessingAllowed?.()===true && privacy?.marketingAllowed?.()===true;}
      catch(_error){return false;}
    };
    const measurementConsent=()=>({analytics:true,attribution:true});
    const shopRoute=(path)=>{
      const prefix=window.Shopify?.routes?.root;
      if(typeof prefix!=='string' || !/^\/(?:[a-zA-Z0-9_-]+\/)*$/.test(prefix)) return null;
      try{const url=new URL(prefix+path,window.location.origin);return url.origin===window.location.origin ? url.pathname : null;}catch(_error){return null;}
    };
    const money = (price, currency) => typeof price==='number' && Number.isFinite(price) && price>0 && currency==='INR' ? new Intl.NumberFormat('en-IN',{style:'currency',currency,maximumFractionDigits:2}).format(price) : null;
    const stringList = (value) => Array.isArray(value) && value.every((item)=>typeof item==='string');
    const validShopping = (value) => value && typeof value==='object' && !Array.isArray(value)
      && ['single','routine'].includes(value.mode) && ['any','prefer','only'].includes(value.brandMode)
      && ['relevance','price_asc','price_desc'].includes(value.sort) && ['per_product','routine'].includes(value.budgetScope)
      && value.currency==='INR' && [value.budgetMin,value.budgetMax].every((amount)=>amount===null || Boolean(money(amount,'INR')))
      && [value.preferredBrands,value.excludedBrands,value.excludedProductIds,value.requestedProductTypes].every(stringList);
    const productLink = (product) => {
      try {
        const url=new URL(product.onlineStoreUrl);
        const variant=String(product.variantId || '').match(/^(?:gid:\/\/shopify\/ProductVariant\/)?(\d+)$/)?.[1];
        if(url.protocol!=='https:' || !['reflexions.in','www.reflexions.in'].includes(url.hostname) || url.port || url.username || url.password || !/^\/products\/[a-zA-Z0-9_-]+\/?$/.test(url.pathname) || !variant || url.searchParams.get('variant')!==variant) return null;
        url.search=''; url.searchParams.set('variant',variant); url.hash='';
        return url.toString();
      } catch (_error) { return null; }
    };
    const imageLink = (value) => {
      try { const url=new URL(value); return url.protocol==='https:' && ['cdn.shopify.com','reflexions.in','www.reflexions.in'].includes(url.hostname) && !url.port && !url.username && !url.password ? url.toString() : null; }
      catch (_error) { return null; }
    };
    const filterPreferences = (shopping, values, changed) => {
      const next=copy(shopping);
      if(changed.has('brands')) { next.preferredBrands=unique(values.brands,8); next.brandMode=next.preferredBrands.length ? 'only' : 'any'; }
      if(changed.has('priceMin') || changed.has('priceMax')) {
        next.budgetMin=values.priceMin==='' ? null : Number(values.priceMin);
        next.budgetMax=values.priceMax==='' ? null : Number(values.priceMax);
        next.currency='INR'; next.unsupportedCurrency=null; next.invalidBudget=false;
      }
      if(changed.has('budgetScope')) next.budgetScope=values.budgetScope;
      next.sort=values.sort;
      return next;
    };
    const initialize = (root) => {
      if(root.dataset.initialized==='true') return;
      root.dataset.initialized='true';
      const node=(name)=>root.querySelector('[data-advisor-'+name+']');
      const status=node('status'),messages=node('messages'),examples=node('examples'),question=node('question'),questionPrompt=node('question-prompt'),questionOptions=node('question-options');
      const consultation=node('consultation'),composer=node('composer'),results=node('results'),restart=node('restart');
      const refinements=node('refinements'),refineForm=node('refine-form'),suggestions=node('suggestions'),comparison=node('comparison'),compare=node('compare');
      const optionalRefinement=node('optional-refinement'),optionalPrompt=node('optional-prompt'),optionalOptions=node('optional-options'),optionalError=node('optional-error');
      const resultControls=node('result-controls'),filterForm=node('filter-form'),brandFilter=node('brand-filter'),brandOptions=node('brand-options');
      const brandCount=node('brand-count'),filterSummary=node('filter-summary'),catalogueRange=node('catalogue-range'),filterError=node('filter-error');
      const editRequest=node('edit-request'),cancelEdit=node('cancel-edit'),editHint=node('edit-hint'),submit=node('submit'),skip=node('skip'),requestSummary=node('request-summary'),resultReply=node('result-reply');
      const input=composer.elements.namedItem('message'),refineInput=refineForm.elements.namedItem('refinement'),messageLabel=node('message-label');
      const cartFeedback=node('cart-feedback'),cartStatus=node('cart-status'),viewBag=node('view-bag');
      const matchesPanel=node('matches-panel'),matchesTab=node('matches-tab'),refineTab=node('refine-tab'),priceFilter=node('price-filter'),safety=node('safety');
      const field=(name)=>filterForm.elements.namedItem(name);
      const baseUrl=root.dataset.apiBaseUrl.replace(/\/$/,'');
      const state={context:null,shopping:null,originalShopping:null,recommendations:[],totalPrice:null,filters:null,lastResult:null,lastSuccessful:null,reply:'',suggestedRefinements:[],transcript:[],question:null,optionalRefinement:null,resetOnNextMessage:false};
      const changed=new Set();
      let requestId=0,activeRequest=null,busy=false,workspaceTab='matches',editReturnTab='matches',editDraft=null;
      const bindTabs=(items,onSelect=()=>{})=>{
        const select=(key,focus=false)=>{
          const selected=items.find((item)=>item.key===key);if(!selected || selected.button.disabled) return;
          items.forEach((item)=>{const active=item===selected;item.button.setAttribute('aria-selected',String(active));item.button.tabIndex=active ? 0 : -1;item.panel.hidden=!active;});
          onSelect(key);if(focus) selected.button.focus({preventScroll:true});
        };
        items.forEach((item)=>{
          item.button.addEventListener('click',()=>select(item.key));
          item.button.addEventListener('keydown',(event)=>{
            const enabled=items.filter((entry)=>!entry.button.disabled && !entry.button.hidden),index=enabled.indexOf(item);
            if(index<0 || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
            event.preventDefault();const next=event.key==='Home' ? 0 : event.key==='End' ? enabled.length-1 : (index+(event.key==='ArrowRight' ? 1 : -1)+enabled.length)%enabled.length;
            select(enabled[next].key,true);
          });
        });return select;
      };
      const selectStarter=bindTabs(['hair','skin','tools'].map((key)=>({key,button:node('starter-'+key),panel:node('starter-panel-'+key)})));
      const selectWorkspace=bindTabs([{key:'matches',button:matchesTab,panel:matchesPanel},{key:'compare',button:compare,panel:comparison},{key:'refine',button:refineTab,panel:refinements}],(key)=>{workspaceTab=key;});
      const hideWorkspace=()=>{matchesPanel.hidden=true;comparison.hidden=true;refinements.hidden=true;};
      const showStatus=(text,tone='quiet')=>{status.textContent=text;status.dataset.tone=tone;};
      let measurement=null,consentEpoch=0;
      const issuedTokens=new Set(),measured=new Set(),measurementRequests=new Set();
      const postMeasurement=(payload,revoking=false)=>{
        const controller=new AbortController();
        if(!revoking) measurementRequests.add(controller);
        try{Promise.resolve(fetch(baseUrl+'/api/advisor/conversion-events',{method:'POST',mode:'cors',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),signal:controller.signal,keepalive:true})).catch(()=>{}).finally(()=>measurementRequests.delete(controller));}
        catch(_error){measurementRequests.delete(controller);}
      };
      const revokeMeasurement=()=>{
        consentEpoch+=1;measurement=null;measurementRequests.forEach((controller)=>controller.abort());measurementRequests.clear();measured.clear();
        const tokens=[...issuedTokens];issuedTokens.clear();
        tokens.forEach((token)=>postMeasurement({token,event:'consent_revoked'},true));
      };
      const validMeasurement=(value)=>value && typeof value.token==='string' && /^[A-Za-z0-9_-]{43}$/.test(value.token) && typeof value.expiresAt==='string' && Number.isFinite(Date.parse(value.expiresAt)) && Date.parse(value.expiresAt)>Date.now();
      const currentMeasurement=(value=measurement)=>{
        if(!measurementAllowed()){if(issuedTokens.size || measurement) revokeMeasurement();return null;}
        return validMeasurement(value) && issuedTokens.has(value.token) ? value : null;
      };
      const measure=(event,variantId,receipt=measurement)=>{
        const active=currentMeasurement(receipt);if(!active) return;
        const key=active.token+'|'+event+'|'+(variantId || '');if(measured.has(key)) return;measured.add(key);
        postMeasurement({token:active.token,event,...(variantId ? {variantId} : {}),measurementConsent:measurementConsent()});
      };
      const acceptMeasurement=(value,allowed)=>{
        measurement=null;
        if(allowed && measurementAllowed() && validMeasurement(value) && (issuedTokens.has(value.token) || issuedTokens.size<50)){
          measurement={token:value.token,expiresAt:value.expiresAt};issuedTokens.add(value.token);
        }
      };
      document.addEventListener('visitorConsentCollected',()=>{if(!measurementAllowed()) revokeMeasurement();});
      const refreshBagButtons=()=>{
        results.querySelectorAll('button').forEach((button)=>{
          const id=button.dataset.advisorAdd;if(!id) return;
          button.disabled=bag.busy || bag.unknown || bag.added.has(id) || bag.present.has(id) || bag.blocked.has(id);
          button.textContent=bag.added.has(id) ? root.dataset.cartAdded : bag.present.has(id) ? root.dataset.cartAlready : bag.current===id && bag.busy ? (bag.phase==='adding' ? root.dataset.cartAdding : root.dataset.cartChecking) : root.dataset.cartAdd;
          button.setAttribute('aria-busy',String(bag.busy && bag.current===id));
        });
      };
      bag.notify.add(refreshBagButtons);
      const notifyBag=()=>bag.notify.forEach((notify)=>notify());
      const showBagStatus=(text)=>{cartStatus.textContent=text;cartFeedback.hidden=false;const route=shopRoute('cart');viewBag.hidden=!route;if(route) viewBag.href=route;};
      const addToBag=async(product,button)=>{
        const id=variantKey(product.variantId),url=productLink(product);
        if(!id || !url || !results.contains(button) || bag.busy || bag.unknown || bag.added.has(id) || bag.present.has(id) || bag.blocked.has(id)) return;
        const path=new URL(url).pathname.replace(/\/$/,''),handle=path.split('/').pop();
        const cartUrl=shopRoute('cart.js'),productUrl=shopRoute('products/'+handle+'.js'),addUrl=shopRoute('cart/add.js');
        if(!cartUrl || !productUrl || !addUrl){showBagStatus(root.dataset.cartProductPage);return;}
        const receipt=currentMeasurement(),view=requestId,controller=new AbortController();
        const timeout=setTimeout(()=>controller.abort(),15000);let posted=false;
        bag.busy=true;bag.current=id;bag.phase='checking';notifyBag();
        try{
          const read=async(path)=>{const response=await fetch(path,{method:'GET',credentials:'same-origin',cache:'no-store',redirect:'error',signal:controller.signal});if(!response.ok) throw new Error('Preflight failed');return response.json();};
          const [cart,fresh]=await Promise.all([read(cartUrl),read(productUrl)]);
          if(view!==requestId || !results.contains(button)) return;
          if(cart?.currency!=='INR' || !Array.isArray(cart.items)){bag.blocked.add(id);showBagStatus(root.dataset.cartCurrency);return;}
          if(cart.items.some((line)=>variantKey(line?.variant_id ?? line?.id)===id && Number.isSafeInteger(line.quantity) && line.quantity>0)){bag.present.add(id);showBagStatus(root.dataset.cartAlreadyNotice);return;}
          if(fresh?.handle!==handle || !Array.isArray(fresh.variants)) throw new Error('Unverified product');
          const variant=fresh.variants.find((item)=>variantKey(item?.id)===id);
          if(!variant || variant.available!==true){bag.blocked.add(id);showBagStatus(root.dataset.cartUnavailable);return;}
          if(fresh.requires_selling_plan===true || variant.requires_selling_plan===true){bag.blocked.add(id);showBagStatus(root.dataset.cartProductPage);return;}
          const price=Math.round(product.price*100);
          if(!Number.isSafeInteger(variant.price) || variant.price!==price){bag.blocked.add(id);showBagStatus(root.dataset.cartPriceChanged);return;}
          const active=currentMeasurement(receipt);
          const item={id,quantity:1,...(active ? {properties:{_ai_connect_advisor:active.token}} : {})};
          bag.phase='adding';notifyBag();posted=true;
          const response=await fetch(addUrl,{method:'POST',credentials:'same-origin',redirect:'error',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item]}),signal:controller.signal});
          if(!response.ok) throw new Error('Bag update uncertain');
          const added=await response.json(),line=Array.isArray(added?.items) && added.items.length===1 ? added.items[0] : null;
          if(!line || variantKey(line.variant_id ?? line.id)!==id || !Number.isSafeInteger(line.quantity) || line.quantity<1 || (line.original_price ?? line.price)!==price) throw new Error('Unverified bag update');
          bag.added.add(id);showBagStatus(root.dataset.cartAddedNotice);measure('cart_added',product.variantId,active);
        }catch(_error){
          if(posted){bag.unknown=true;showBagStatus(root.dataset.cartUnknown);}
          else if(view===requestId) showBagStatus(root.dataset.cartCheckFailed);
        }finally{clearTimeout(timeout);bag.busy=false;bag.current=null;bag.phase='';notifyBag();}
      };
      const selectedBrands=()=>Array.from(brandOptions.querySelectorAll('input:checked')).map((checkbox)=>checkbox.value);
      const clearFilterError=()=>{filterError.hidden=true;filterError.textContent='';field('priceMax').setCustomValidity('');};
      const renderTranscript=()=>{
        messages.replaceChildren();
        const turns=state.transcript.slice(-2);messages.hidden=!turns.length;
        turns.forEach((turn)=>messages.append(textNode('p',turn.text,'beauty-advisor__bubble'+(turn.who==='user'?' beauty-advisor__bubble--user':''))));
      };
      const setBusy=(value)=>{
        busy=value;
        [composer,filterForm,refineForm].forEach((form)=>{
          form.setAttribute('aria-busy',String(value));form.querySelectorAll('input,select,button').forEach((element)=>{element.disabled=value || element.dataset.excluded==='true';});
        });
        [examples,questionOptions,suggestions,optionalOptions].forEach((group)=>group.querySelectorAll('button').forEach((button)=>{button.disabled=value;}));
        optionalRefinement.setAttribute('aria-busy',String(value));
        results.setAttribute('aria-busy',String(value));editRequest.disabled=value;
        compare.disabled=value || state.recommendations.length<2 || state.shopping?.mode==='routine';
      };
      const reset=(focus=false)=>{
        requestId+=1;activeRequest?.abort();activeRequest=null;
        measurement=null;
        Object.assign(state,{context:null,shopping:null,originalShopping:null,recommendations:[],totalPrice:null,filters:null,lastResult:null,lastSuccessful:null,reply:'',suggestedRefinements:[],transcript:[],question:null,optionalRefinement:null,resetOnNextMessage:false});
        changed.clear();composer.reset();filterForm.reset();refineForm.reset();brandOptions.replaceChildren();questionOptions.replaceChildren();suggestions.replaceChildren();setBusy(false);selectStarter('hair');selectWorkspace('matches');hideWorkspace();comparison.replaceChildren();clearFilterError();
        root.dataset.view='intro';consultation.hidden=false;messages.hidden=false;examples.hidden=false;question.hidden=true;
        results.replaceChildren();results.hidden=true;resultControls.hidden=true;refinements.hidden=true;restart.hidden=true;composer.hidden=false;skip.hidden=true;
        cancelEdit.hidden=true;editHint.hidden=true;submit.textContent=root.dataset.adaptiveSubmit;brandFilter.open=false;priceFilter.open=false;editDraft=null;safety.replaceChildren();safety.hidden=true;
        optionalRefinement.hidden=true;optionalRefinement.open=false;optionalOptions.replaceChildren();optionalError.hidden=true;optionalError.textContent='';
        messageLabel.textContent=root.dataset.messageLabel;input.placeholder=root.dataset.messagePlaceholder;
        renderTranscript();showStatus(root.dataset.ready);if(focus) input.focus();
      };
      const renderBrands=()=>{
        const available=unique([...(state.filters?.brands || []),...(state.shopping?.preferredBrands || []),...(state.originalShopping?.preferredBrands || [])],80).sort((a,b)=>a.localeCompare(b));
        const chosen=new Set(state.shopping.brandMode==='only' ? state.shopping.preferredBrands.map((brand)=>brand.toLocaleLowerCase()) : []);
        const excluded=new Set(state.shopping.excludedBrands.map((brand)=>brand.toLocaleLowerCase()));
        brandOptions.replaceChildren();
        available.forEach((brand)=>{
          const label=document.createElement('label');label.className='beauty-advisor__checkbox';
          const checkbox=document.createElement('input');checkbox.type='checkbox';checkbox.name='brands';checkbox.value=brand;checkbox.checked=chosen.has(brand.toLocaleLowerCase());
          checkbox.dataset.excluded=String(excluded.has(brand.toLocaleLowerCase()));checkbox.disabled=checkbox.dataset.excluded==='true';
          if(checkbox.disabled) label.title=root.dataset.originalExclusion;
          label.append(checkbox,textNode('span',brand+(checkbox.disabled ? ' · '+root.dataset.excluded : '')));brandOptions.append(label);
        });brandCount.textContent=chosen.size ? '('+chosen.size+')' : '';
      };
      const syncFilters=()=>{
        field('priceMin').value=state.shopping.budgetMin ?? '';field('priceMax').value=state.shopping.budgetMax ?? '';
        field('sort').value=state.shopping.sort;field('budgetScope').value=state.shopping.budgetScope;
        node('scope').hidden=state.shopping.mode!=='routine';renderBrands();changed.clear();clearFilterError();
        const summary=[];
        if(state.shopping.preferredBrands.length) summary.push((state.shopping.brandMode==='only' ? root.dataset.selected : root.dataset.preferred)+': '+state.shopping.preferredBrands.join(', '));
        const minimum=money(state.shopping.budgetMin,'INR'),maximum=money(state.shopping.budgetMax,'INR');
        if(minimum || maximum) summary.push((minimum && maximum ? minimum+' – '+maximum : minimum ? '≥ '+minimum : '≤ '+maximum)+(state.shopping.mode==='routine' ? ' · '+(state.shopping.budgetScope==='routine' ? root.dataset.totalRoutine : root.dataset.perProduct) : ''));
        if(state.shopping.excludedBrands.length) summary.push(root.dataset.excluded+': '+state.shopping.excludedBrands.join(', '));
        filterSummary.textContent=summary.length ? summary.join('  ·  ') : root.dataset.allMatches;
        filterSummary.hidden=!summary.length;
        const rangeMin=money(state.filters?.priceMin,'INR'),rangeMax=money(state.filters?.priceMax,'INR');
        catalogueRange.textContent=rangeMin && rangeMax ? root.dataset.priceRange+': '+rangeMin+' – '+rangeMax : '';catalogueRange.hidden=!catalogueRange.textContent;
      };
      const renderComparison=()=>{
        const table=document.createElement('table');table.append(textNode('caption',root.dataset.compare));
        const head=document.createElement('thead'),header=document.createElement('tr'),corner=textNode('th',root.dataset.detailsLabel);corner.scope='col';header.append(corner);
        state.recommendations.forEach((item)=>{const heading=textNode('th',item.product.title);heading.scope='col';header.append(heading);});head.append(header);table.append(head);
        const body=document.createElement('tbody');
        [[root.dataset.brandLabel,(item)=>item.product.vendor || root.dataset.unspecified],
          [root.dataset.sizeLabel,(item)=>comparisonSize(item.product) || root.dataset.unspecified],
          [root.dataset.priceLabel,(item)=>money(item.product.price,item.product.currencyCode)],
          [root.dataset.fitLabel,(item)=>item.explanation?.fit?.[0] || item.reasons?.[0] || root.dataset.unspecified]].forEach(([label,value])=>{
          const row=document.createElement('tr'),heading=textNode('th',label);heading.scope='row';row.append(heading);
          state.recommendations.forEach((item)=>row.append(textNode('td',value(item))));body.append(row);
        });table.append(body);comparison.replaceChildren(table);
      };
      const renderSuggestions=()=>{
        suggestions.replaceChildren();
        unique(state.suggestedRefinements,3).forEach((text)=>{const button=textNode('button',text);button.type='button';button.dataset.refinement=text;suggestions.append(button);});
        suggestions.hidden=!suggestions.children.length;
      };
      const renderOptionalRefinement=()=>{
        const detail=state.optionalRefinement;
        optionalOptions.replaceChildren();optionalError.hidden=true;optionalError.textContent='';
        optionalRefinement.hidden=!detail;
        if(!detail){optionalRefinement.open=false;return;}
        optionalPrompt.textContent=detail.prompt;
        detail.options.slice(0,8).forEach((option)=>{if(!option || typeof option.label!=='string' || typeof option.value!=='string') return;const button=textNode('button',option.label);button.type='button';button.dataset.optionalAnswer=option.value;optionalOptions.append(button);});
      };
      const renderResults=(result)=>{
        const heading=textNode('h2',state.recommendations.length ? root.dataset.matchesLabel+' ('+state.recommendations.length+')' : root.dataset.noMatchesLabel);results.replaceChildren(heading);
        if(!state.recommendations.length) results.append(textNode('p',result.noMatchReason || root.dataset.noMatch,'beauty-advisor__reason'));
        const grid=document.createElement('div');grid.className='beauty-advisor__result-grid';
        state.recommendations.forEach((recommendation,index)=>{
          const product=recommendation.product,single=state.shopping.mode!=='routine',best=single && index===0 && state.shopping.sort==='relevance';
          const card=document.createElement('article');card.className='beauty-advisor__card'+(best ? ' beauty-advisor__card--best' : '');
          const imageUrl=imageLink(product.imageUrl);
          if(imageUrl){const image=document.createElement('img');image.src=imageUrl;image.alt=product.title;image.loading=index<3 ? 'eager' : 'lazy';image.decoding='async';image.width=480;image.height=480;image.addEventListener('error',()=>{image.hidden=true;});card.append(image);}
          const body=document.createElement('div');body.className='beauty-advisor__card-body';
          const label=!single ? root.dataset.routinePick : index>0 ? root.dataset.alternative : state.shopping.sort==='price_asc' ? root.dataset.lowestPrice : state.shopping.sort==='price_desc' ? root.dataset.highestPrice : root.dataset.bestMatch;
          body.append(textNode('p',label,'beauty-advisor__role'),textNode('h3',product.title));
          const variant=[product.vendor,product.variantTitle && product.variantTitle!=='Default Title' ? product.variantTitle : null].filter(Boolean).join(' · ');
          if(variant) body.append(textNode('p',variant,'beauty-advisor__variant'));
          body.append(textNode('p',money(product.price,product.currencyCode),'beauty-advisor__price'));
          const allFits=unique(recommendation.explanation?.fit || recommendation.reasons || [],4);
          const tradeOffs=unique(recommendation.explanation?.tradeOffs || [],4);
          const evidence=unique([...allFits,...tradeOffs,...(recommendation.explanation?.evidence || [])],12);
          const purchase=document.createElement('div');purchase.className='beauty-advisor__purchase';
          const add=textNode('button',root.dataset.cartAdd,'beauty-advisor__add');add.type='button';add.dataset.advisorAdd=variantKey(product.variantId);add.addEventListener('click',()=>addToBag(product,add));purchase.append(add);
          const link=textNode('a',root.dataset.cartDetails,'beauty-advisor__product-link');link.href=productLink(product);link.addEventListener('click',()=>{if(results.contains(link)) measure('product_click',product.variantId);});purchase.append(link);body.append(purchase);
          if(evidence.length || recommendation.howToUse){const details=document.createElement('details');details.className='beauty-advisor__evidence';details.append(textNode('summary',root.dataset.evidence));const list=document.createElement('ul');evidence.forEach((text)=>list.append(textNode('li',text)));details.append(list);if(recommendation.howToUse) details.append(textNode('p',recommendation.howToUse));body.append(details);}
          card.append(body);grid.append(card);
        });
        if(state.recommendations.length){
          results.append(grid);
          if(state.shopping.mode==='routine' && money(state.totalPrice,'INR')) results.append(textNode('p',root.dataset.routineTotal+': '+money(state.totalPrice,'INR'),'beauty-advisor__total'));
        }
        const important=(text)=>/qualified|dermatolog|doctor|clinician|pregnan|breastfeed|sudden|patchy|severe|persistent|irritat|allerg|stop use|seek care|pain|rash|medical attention/i.test(text);
        const notices=unique([...(Array.isArray(result.cautions) ? result.cautions : []),...[state.reply,result.summary,result.rationale,result.disclaimer,...state.recommendations.flatMap((item)=>[...(item.explanation?.tradeOffs || []),item.howToUse])].filter((text)=>typeof text==='string').flatMap((text)=>text.match(/[^.!?]+[.!?]*/g) || []).filter(important)],20);
        safety.replaceChildren();notices.forEach((text)=>safety.append(textNode('p',text)));safety.hidden=!notices.length;
        root.dataset.view='results';consultation.hidden=true;resultControls.hidden=false;results.hidden=false;restart.hidden=false;
        compare.hidden=false;compare.disabled=state.recommendations.length<2 || state.shopping.mode==='routine';
        requestSummary.textContent=state.context?.originalMessage || '';requestSummary.title=requestSummary.textContent;
        resultReply.replaceChildren();unique([state.reply,result.summary,result.rationale,root.dataset.priceNote],4).forEach((text)=>resultReply.append(textNode('p',text)));
        renderSuggestions();renderOptionalRefinement();renderComparison();selectWorkspace('matches',true);refreshBagButtons();
      };
      const validateResult=(result)=>{
        if(!validShopping(result?.shopping) || !Array.isArray(result.recommendations)) throw new Error('Invalid recommendations');
        if(result.filters && !stringList(result.filters.brands)) throw new Error('Invalid brand choices');
        const routine=result.shopping.mode==='routine';
        if(routine && result.recommendations.length>8) throw new Error('Unexpected routine size');
        const candidates=result.recommendations.slice(0,routine ? 8 : 3);
        if(candidates.some((item)=>!item?.product || typeof item.product.title!=='string' || !variantKey(item.product.variantId) || !money(item.product.price,item.product.currencyCode) || !productLink(item.product)
          || (item.reasons!=null && !stringList(item.reasons))
          || ['fit','tradeOffs','evidence'].some((key)=>item.explanation?.[key]!=null && !stringList(item.explanation[key])))) throw new Error('Unverified product variant');
        if(routine && candidates.length && (!money(result.totalPrice,'INR') || Math.abs(result.totalPrice-candidates.reduce((total,item)=>total+item.product.price,0))>0.01)) throw new Error('Unverified routine total');
        return candidates;
      };
      const applyResult=(result,candidates,resetBaseline=false,measurementEligible=false)=>{
        acceptMeasurement(result.measurement,measurementEligible);result={...result};delete result.measurement;
        state.shopping=copy(result.shopping);state.recommendations=candidates;state.totalPrice=result.totalPrice ?? null;state.filters=result.filters || {brands:[],priceMin:null,priceMax:null,currency:'INR'};state.lastResult=result;
        state.context={...state.context,shopping:copy(result.shopping)};
        if(resetBaseline || !state.originalShopping) state.originalShopping=copy(result.shopping);
        state.question=null;state.resetOnNextMessage=false;
        syncFilters();renderResults(result);showStatus(candidates.length ? root.dataset.updated : root.dataset.noMatchStatus);
        state.lastSuccessful=copy({context:state.context,originalShopping:state.originalShopping,reply:state.reply,suggestedRefinements:state.suggestedRefinements,optionalRefinement:state.optionalRefinement,transcript:state.transcript,result});
        editDraft=null;editReturnTab='matches';
        if(candidates.length) measure('shown');
      };
      const performRequest=async(path,payload,kind,onSuccess)=>{
        if(busy) return;
        activeRequest?.abort();activeRequest=new AbortController();const currentRequest=++requestId,controller=activeRequest;
        const timeout=setTimeout(()=>controller.abort(),30000);
        const keepResults=kind==='optional-refinement';
        if(!keepResults){results.hidden=true;hideWorkspace();}else selectWorkspace('refine');
        optionalError.hidden=true;optionalError.textContent='';restart.hidden=false;brandFilter.open=false;priceFilter.open=false;examples.hidden=true;
        if(kind==='consultation'){consultation.hidden=false;messages.hidden=false;resultControls.hidden=true;composer.hidden=false;question.hidden=true;skip.hidden=true;cancelEdit.hidden=!state.lastSuccessful;input.value=payload.message;}
        setBusy(true);showStatus(root.dataset.thinking,'working');
        try{
          const allowed=measurementAllowed(),epoch=consentEpoch,requestPayload={...payload,...(allowed ? {measurementConsent:measurementConsent()} : {})};
          const response=await fetch(baseUrl+path,{method:'POST',mode:'cors',headers:{'Content-Type':'application/json'},body:JSON.stringify(requestPayload),signal:controller.signal});
          if(currentRequest!==requestId) return;if(!response.ok) throw new Error('Advisor request failed');
          const result=await response.json();if(currentRequest!==requestId) return;
          onSuccess(result,allowed && epoch===consentEpoch && measurementAllowed());
        }catch(_error){
          if(currentRequest!==requestId) return;showStatus(root.dataset.error,'error');
          if(keepResults){selectWorkspace('refine');optionalError.textContent=root.dataset.error;optionalError.hidden=false;optionalRefinement.open=true;}
          else if(kind==='catalogue'){results.replaceChildren(textNode('p',root.dataset.error,'beauty-advisor__reason'));results.hidden=false;selectWorkspace('matches');}
          else{results.replaceChildren();results.hidden=true;hideWorkspace();}
          if(kind==='consultation'){
            composer.hidden=false;input.value=payload.message;cancelEdit.hidden=!state.lastSuccessful;
            question.hidden=!state.question;skip.hidden=!state.question;
            if(state.question) questionPrompt.focus({preventScroll:true});
          }
        }finally{clearTimeout(timeout);if(currentRequest===requestId){activeRequest=null;setBusy(false);}}
      };
      const requestConsultation=(message,action='message',displayMessage=message,keepResults=false)=>{
        if(busy || (action==='message' && !message.trim()) || (action==='skip' && (!state.context || !state.question))) return;
        const fresh=!state.context || state.resetOnNextMessage;
        const context=fresh ? undefined : copy({...state.context,shopping:state.shopping || state.context.shopping});
        const payload={message:message.trim(),...(context ? {context} : {}),action,source:'advisor_page',limit:Math.max(4,Math.min(8,Number(root.dataset.resultLimit) || 4))};
        performRequest('/api/advisor/consultation',payload,keepResults ? 'optional-refinement' : 'consultation',(response,measurementEligible)=>{
          if(!['clarify','recommend','handoff'].includes(response.status) || !validShopping(response.context?.shopping) || typeof response.context.originalMessage!=='string' || !stringList(response.context.goals)) throw new Error('Invalid consultation response');
          if(keepResults && response.status==='clarify') throw new Error('Optional refinement cannot block existing matches');
          if(response.status==='clarify' && (!response.question || !Array.isArray(response.question.options) || typeof response.question.prompt!=='string')) throw new Error('Missing consultation question');
          const candidates=response.status==='recommend' ? validateResult(response.result) : null;
          state.context=copy(response.context);state.shopping=copy(response.context.shopping);state.reply=typeof response.reply==='string' ? response.reply : '';
          state.question=response.question;state.suggestedRefinements=Array.isArray(response.suggestedRefinements) ? response.suggestedRefinements : [];state.resetOnNextMessage=false;
          const optional=response.optionalRefinement;
          state.optionalRefinement=response.status==='recommend' && optional && typeof optional.id==='string' && typeof optional.prompt==='string' && Array.isArray(optional.options) ? copy(optional) : null;
          if(fresh) optionalRefinement.open=false;
          if(fresh) state.transcript=[];
          if(action==='message') state.transcript.push({text:displayMessage,who:'user'});
          if(state.reply && state.reply!==response.question?.prompt) state.transcript.push({text:state.reply,who:'assistant'});
          state.transcript=state.transcript.slice(-24);renderTranscript();input.value='';refineInput.value='';
          if(response.status==='recommend'){
            applyResult(response.result,candidates,true,measurementEligible);resultControls.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});return;
          }
          root.dataset.view='consultation';consultation.hidden=false;resultControls.hidden=true;results.hidden=true;hideWorkspace();safety.hidden=true;examples.hidden=true;editHint.hidden=true;
          questionOptions.replaceChildren();question.hidden=response.status!=='clarify';skip.hidden=response.status!=='clarify';composer.hidden=response.status==='handoff';cancelEdit.hidden=!state.lastSuccessful;
          if(response.status==='clarify'){
            questionPrompt.textContent=response.question.prompt;questionPrompt.focus({preventScroll:true});
            response.question.options.slice(0,8).forEach((option)=>{if(!option || typeof option.label!=='string' || typeof option.value!=='string') return;const button=textNode('button',option.label);button.type='button';button.dataset.answer=option.value;questionOptions.append(button);});
            messageLabel.textContent=root.dataset.answerLabel;input.placeholder=root.dataset.answerPlaceholder;submit.textContent=root.dataset.continue;showStatus(root.dataset.questionStatus);
          }else{showStatus(root.dataset.handoffStatus,'important');messages.focus({preventScroll:true});}
        });
      };
      const requestCatalogue=(shopping)=>{
        if(!state.context?.category || busy) return;
        const payload={category:state.context.category,goals:state.context.goals,profile:state.context.profile,...(state.context.category==='hair' && state.context.hairLoss ? {hairLoss:copy(state.context.hairLoss)} : {}),message:state.context.originalMessage,shopping,source:'advisor_page',limit:Math.max(4,Math.min(8,Number(root.dataset.resultLimit) || 4))};
        performRequest('/api/advisor/catalogue-recommendations',payload,'catalogue',(result,measurementEligible)=>{const candidates=validateResult(result);state.reply='';applyResult(result,candidates,false,measurementEligible);resultControls.scrollIntoView({behavior:'auto',block:'start'});});
      };
      composer.addEventListener('submit',(event)=>{event.preventDefault();if(!busy && composer.reportValidity()) requestConsultation(input.value);});
      skip.addEventListener('click',()=>requestConsultation('','skip'));
      examples.addEventListener('click',(event)=>{const button=event.target.closest('[data-example]');if(button && typeof button.dataset.example==='string' && examples.contains(button)) requestConsultation(button.dataset.example);});
      questionOptions.addEventListener('click',(event)=>{const button=event.target.closest('[data-answer]');if(button && questionOptions.contains(button)) requestConsultation(button.dataset.answer,'message',button.textContent);});
      optionalOptions.addEventListener('click',(event)=>{const button=event.target.closest('[data-optional-answer]');if(button && optionalOptions.contains(button)) requestConsultation(button.dataset.optionalAnswer,'message',button.textContent,true);});
      refineForm.addEventListener('submit',(event)=>{event.preventDefault();if(!busy && refineForm.reportValidity()) requestConsultation(refineInput.value);});
      suggestions.addEventListener('click',(event)=>{const button=event.target.closest('[data-refinement]');if(button && suggestions.contains(button)) requestConsultation(button.dataset.refinement);});
      filterForm.addEventListener('input',(event)=>{
        clearFilterError();if(event.target.name) changed.add(event.target.name);
        if(event.target.name==='brands'){const selected=selectedBrands();if(selected.length>8){event.target.checked=false;filterError.textContent=root.dataset.brandLimit;filterError.hidden=false;}brandCount.textContent=selectedBrands().length ? '('+selectedBrands().length+')' : '';}
      });
      filterForm.addEventListener('submit',(event)=>{
        event.preventDefault();if(busy || !state.shopping) return;clearFilterError();
        const values={brands:selectedBrands(),priceMin:field('priceMin').value,priceMax:field('priceMax').value,budgetScope:field('budgetScope').value,sort:field('sort').value};
        if(values.priceMin!=='' && values.priceMax!=='' && Number(values.priceMin)>Number(values.priceMax)){priceFilter.open=true;field('priceMax').setCustomValidity(root.dataset.invalidRange);}
        if(!filterForm.reportValidity()) return;requestCatalogue(filterPreferences(state.shopping,values,changed));
      });
      filterForm.addEventListener('invalid',(event)=>{if([field('priceMin'),field('priceMax')].includes(event.target)){selectWorkspace('matches');priceFilter.open=true;}},true);
      node('reset-filters').addEventListener('click',()=>{if(!busy && state.originalShopping) requestCatalogue(copy(state.originalShopping));});
      brandFilter.addEventListener('keydown',(event)=>{if(event.key==='Escape'){brandFilter.open=false;brandFilter.querySelector('summary')?.focus();}});
      priceFilter.addEventListener('keydown',(event)=>{if(event.key==='Escape'){priceFilter.open=false;priceFilter.querySelector('summary')?.focus();}});
      editRequest.addEventListener('click',()=>{
        if(busy) return;editReturnTab=workspaceTab;editDraft={brands:selectedBrands(),priceMin:field('priceMin').value,priceMax:field('priceMax').value,sort:field('sort').value,budgetScope:field('budgetScope').value,refinement:refineInput.value,changed:[...changed]};state.resetOnNextMessage=true;consultation.hidden=false;messages.hidden=true;composer.hidden=false;resultControls.hidden=true;results.hidden=true;hideWorkspace();question.hidden=true;examples.hidden=true;skip.hidden=true;
        input.value=state.context?.originalMessage || '';cancelEdit.hidden=false;editHint.hidden=false;messageLabel.textContent=root.dataset.messageLabel;input.placeholder=root.dataset.messagePlaceholder;submit.textContent=root.dataset.updateRequest;input.focus();
      });
      cancelEdit.addEventListener('click',()=>{
        if(busy || !state.lastSuccessful) return;
        const draft=editDraft,returnTab=editReturnTab;
        const saved=copy(state.lastSuccessful);state.context=saved.context;state.originalShopping=saved.originalShopping;state.reply=saved.reply;state.suggestedRefinements=saved.suggestedRefinements;state.optionalRefinement=saved.optionalRefinement || null;state.transcript=saved.transcript;
        applyResult(saved.result,validateResult(saved.result));input.value='';
        if(draft){['priceMin','priceMax','sort','budgetScope'].forEach((name)=>{field(name).value=draft[name];});brandOptions.querySelectorAll('input').forEach((checkbox)=>{checkbox.checked=draft.brands.includes(checkbox.value);});refineInput.value=draft.refinement;draft.changed.forEach((name)=>changed.add(name));brandCount.textContent=draft.brands.length ? '('+draft.brands.length+')' : '';}
        selectWorkspace(returnTab==='compare' && compare.disabled ? 'matches' : returnTab,true);
      });
      restart.addEventListener('click',()=>reset(true));reset();
    };
    document.querySelectorAll('[data-beauty-advisor]').forEach(initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-article"]) return;
  try {
    
  if (!customElements.get('rx-article-progress')) {
    customElements.define('rx-article-progress', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('span');
        this.wrap = this.closest('.rx-article');
        this.onScroll = this.update.bind(this);
        addEventListener('scroll', this.onScroll, { passive: true });
        addEventListener('resize', this.onScroll);
        this.update();
      }

      update() {
        if (!this.wrap || !this.bar) return;
        var rect = this.wrap.getBoundingClientRect();
        var total = rect.height - innerHeight;
        var read = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 1;
        this.bar.style.transform = 'scaleX(' + read + ')';
      }

      disconnectedCallback() {
        removeEventListener('scroll', this.onScroll);
        removeEventListener('resize', this.onScroll);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-beauty-advisor-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rx-advisor-page')) customElements.define('rx-advisor-page', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-advisor-form]')
      this.status = this.querySelector('[data-status]')
      this.results = this.querySelector('[data-results]')
      this.summary = this.querySelector('[data-summary]')
      this.recommendations = this.querySelector('[data-recommendations]')
      this.routineButton = this.querySelector('[data-add-routine]')
      this.routineLabel = this.querySelector('[data-routine-label]')
      this.routineUrls = []
      this.category = ''
      this.querySelectorAll('[data-category]').forEach(button => button.addEventListener('click', () => this.selectCategory(button)))
      this.form.addEventListener('submit', event => this.submit(event))
      this.form.addEventListener('reset', () => setTimeout(() => this.reset(), 0))
      this.routineButton.addEventListener('click', () => this.addRoutine())
    }

    selectCategory(selected) {
      this.category = selected.dataset.category
      this.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button === selected)))
      this.querySelectorAll('[data-goals]').forEach(group => {
        group.hidden = group.dataset.goals !== this.category
        if (group.hidden) group.querySelectorAll('input').forEach(input => { input.checked = false })
      })
      this.status.textContent = ''
    }

    reset() {
      this.category = ''
      this.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed', 'false'))
      this.querySelectorAll('[data-goals]').forEach(group => { group.hidden = true })
      this.results.hidden = true
      this.status.textContent = ''
    }

    async submit(event) {
      event.preventDefault()
      const goal = this.querySelector('input[name=advisor-goal]:checked')
      if (!this.category || !goal) {
        this.status.textContent = this.dataset.required
        return
      }
      const submit = this.querySelector('[data-submit]')
      submit.disabled = true
      this.status.textContent = this.dataset.thinking
      try {
        const baseUrl = this.dataset.apiBaseUrl.replace(/\/$/, '')
        const profile = this.querySelector('[data-profile]').value.trim()
        const response = await fetch(`${baseUrl}/api/advisor/catalogue-recommendations`, {
          method: 'POST',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ category: this.category, goals: [goal.value], profile, message: `Build a considered ${this.category} routine for ${goal.value}. ${profile}`, limit: 6, source: 'advisor_page' })
        })
        if (!response.ok) throw new Error('Advisor unavailable')
        this.render(await response.json())
        this.status.textContent = ''
      } catch (_error) {
        this.status.textContent = 'The advisor is briefly unavailable — please try again in a moment.'
      } finally {
        submit.disabled = false
      }
    }

    render(result) {
      this.summary.textContent = result.summary || result.rationale || this.dataset.summaryFallback
      this.recommendations.replaceChildren()
      this.routineUrls = []
      ;(result.recommendations || []).slice(0, 6).forEach(item => {
        const product = item.product || {}
        const safeProductUrl = this.safeUrl(product.onlineStoreUrl, '')
        if (safeProductUrl) this.routineUrls.push(safeProductUrl)
        const card = document.createElement('article')
        card.className = 'rx-advisor-page__recommendation'
        const link = document.createElement('a')
        link.className = 'rx-advisor-page__recommendation-media'
        link.href = safeProductUrl || '#'
        if (product.imageUrl) {
          const image = document.createElement('img')
          image.src = this.safeUrl(product.imageUrl, '')
          image.alt = product.title || ''
          image.loading = 'lazy'
          link.append(image)
        }
        const copy = document.createElement('div')
        const role = document.createElement('small')
        role.textContent = item.role || this.dataset.roleFallback
        const title = document.createElement('a')
        title.className = 'rx-advisor-page__recommendation-title'
        title.href = link.href
        title.textContent = product.title || this.dataset.productFallback
        const action = document.createElement('button')
        action.type = 'button'
        const actionLabel = document.createElement('span')
        actionLabel.textContent = this.dataset.addToCart
        const actionIcon = document.createElement('span')
        actionIcon.setAttribute('aria-hidden', 'true')
        actionIcon.textContent = '+'
        action.append(actionLabel, actionIcon)
        action.setAttribute('aria-label', `${this.dataset.addToCart}: ${product.title || this.dataset.productFallback}`)
        action.addEventListener('click', async () => {
          action.disabled = true
          action.setAttribute('aria-busy', 'true')
          const outcome = await this.addProductByUrl(safeProductUrl)
          action.removeAttribute('aria-busy')
          if (outcome === 'sold-out') {
            actionLabel.textContent = this.dataset.soldOut
            return
          }
          if (outcome === 'added') {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { source: 'rx-advisor-page' } }))
          }
          action.disabled = false
        })
        copy.append(role, title, action)
        card.append(link, copy)
        this.recommendations.append(card)
      })
      this.routineButton.hidden = this.routineUrls.length < 2
      this.routineButton.disabled = false
      this.routineLabel.textContent = 'Add the complete routine to cart'
      this.results.hidden = false
      this.results.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    async addRoutine() {
      if (!this.routineUrls.length) return
      this.routineButton.disabled = true
      let added = 0
      for (const url of this.routineUrls) {
        this.routineLabel.textContent = `Adding ${added + 1} of ${this.routineUrls.length}…`
        const outcome = await this.addProductByUrl(url)
        if (outcome === 'added') added += 1
      }
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { source: 'rx-advisor-page' } }))
      this.routineLabel.textContent = added === this.routineUrls.length ? 'Routine added to cart' : `${added} of ${this.routineUrls.length} added — others unavailable`
    }

    async addProductByUrl(productUrl) {
      try {
        if (!productUrl) return 'failed'
        const source = new URL(productUrl, window.location.origin)
        if (source.origin !== window.location.origin) return 'failed'
        const productResponse = await fetch(`${source.pathname.replace(/\/$/, '')}.js`, { headers: { Accept: 'application/json' } })
        if (!productResponse.ok) return 'failed'
        const product = await productResponse.json()
        const requestedVariantId = Number(source.searchParams.get('variant'))
        const variant = product.variants.find(item => item.available && item.id === requestedVariantId) || product.variants.find(item => item.available)
        if (!variant) return 'sold-out'
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: variant.id, quantity: 1 })
        })
        if (!cartResponse.ok) return 'failed'
        return 'added'
      } catch (_error) {
        return 'failed'
      }
    }

    safeUrl(value, fallback) {
      try {
        const url = new URL(value, window.location.origin)
        if (url.protocol === 'https:' || url.protocol === 'http:') return url.href
      } catch (_error) {
        return fallback
      }
      return fallback
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-concern-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rx-concern-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-rx-concern-track]');
    const previous = carousel.querySelector('[data-rx-concern-prev]');
    const next = carousel.querySelector('[data-rx-concern-next]');

    if (!track || !previous || !next) return;

    const move = (direction) => {
      const card = track.querySelector('.rx-concern');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-guided-brand-collection"] && !Shopify.designMode) return;
  try {
    
  class GuidedBrand extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-rx-guide-tab]')]
      this.panels = [...this.querySelectorAll('[data-rx-guide-panel]')]
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab.dataset.rxGuideTab)))
      this.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return
        const current = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')
        const direction = event.key === 'ArrowRight' ? 1 : -1
        const next = (current + direction + this.tabs.length) % this.tabs.length
        this.select(this.tabs[next].dataset.rxGuideTab)
        this.tabs[next].focus()
      })
    }
    select(id) {
      this.tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.rxGuideTab === id)))
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.rxGuidePanel !== id })
    }
  }
  if (!customElements.get('guided-brand')) customElements.define('guided-brand', GuidedBrand)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-instagram-reel-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('instagram-reels')) {
    customElements.define('instagram-reels', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';
        this.load();
      }

      safeUrl(value, fallback = '') {
        try {
          const url = new URL(value, window.location.origin);
          if (url.protocol === 'https:' || url.protocol === 'http:') return url.href;
        } catch (error) {
          return fallback;
        }
        return fallback;
      }

      reelCard(item, profileUrl) {
        const article = document.createElement('article');
        article.className = 'rx-reels__card';
        article.setAttribute('role', 'listitem');

        const link = document.createElement('a');
        link.className = 'rx-reels__media';
        link.href = this.safeUrl(item.permalink, profileUrl);
        link.target = '_blank';
        link.rel = 'noopener';
        link.setAttribute('aria-label', item.caption ? `View Instagram Reel: ${item.caption}` : 'View Instagram Reel');

        const image = document.createElement('img');
        image.src = this.safeUrl(item.thumbnail_url || item.media_url);
        image.alt = item.caption || 'Reflexions Instagram Reel';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.width = 720;
        image.height = 1280;
        link.append(image);

        const shade = document.createElement('span');
        shade.className = 'rx-reels__shade';
        link.append(shade);

        const play = document.createElement('span');
        play.className = 'rx-reels__play';
        play.setAttribute('aria-hidden', 'true');
        play.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10"></circle><path d="M10 8.5l6 3.5-6 3.5z"></path></svg>';
        link.append(play);

        const instagram = document.createElement('span');
        instagram.className = 'rx-reels__instagram';
        instagram.setAttribute('aria-hidden', 'true');
        instagram.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><rect x="3.5" y="3.5" width="17" height="17" rx="5"></rect><circle cx="12" cy="12" r="4"></circle><circle cx="17.5" cy="6.5" r=".8"></circle></svg>';
        link.append(instagram);

        if (item.caption) {
          const caption = document.createElement('span');
          caption.className = 'rx-reels__caption';
          caption.textContent = item.caption;
          link.append(caption);
        }

        article.append(link);
        return article;
      }

      async load() {
        const endpoint = this.dataset.endpoint;
        const track = this.querySelector('[data-reels-track]');
        const status = this.querySelector('[data-reels-status]');
        if (!endpoint || !track) return;

        try {
          const url = new URL(endpoint, window.location.origin);
          url.searchParams.set('limit', this.dataset.limit || '6');
          const response = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(`Feed request failed: ${response.status}`);
          const payload = await response.json();
          const items = Array.isArray(payload) ? payload : payload.data;
          if (!Array.isArray(items) || !items.length) return;

          const profileUrl = this.safeUrl(this.dataset.profileUrl, 'https://www.instagram.com/');
          const fragment = document.createDocumentFragment();
          items.slice(0, Number(this.dataset.limit) || 6).forEach((item) => {
            if (item && (item.thumbnail_url || item.media_url) && item.permalink) {
              fragment.append(this.reelCard(item, profileUrl));
            }
          });

          if (fragment.childElementCount) {
            track.replaceChildren(fragment);
            if (status) status.textContent = 'Latest Instagram Reels loaded.';
          }
        } catch (error) {
          if (status) status.textContent = 'Showing selected Instagram posts.';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-loyalty-page"] && !Shopify.designMode) return;
  try {
    
  class RxLoyaltyPage extends HTMLElement {
    connectedCallback() {
      this.updateBalance()
      window.setTimeout(() => this.updateBalance(), 1600)
    }

    updateBalance() {
      const balance = window.Smile?.customer?.points_balance
      const target = this.querySelector('[data-smile-balance]')
      if (target && Number.isFinite(Number(balance))) {
        target.textContent = `${Number(balance).toLocaleString()} points available`
      }
    }
  }

  if (!customElements.get('rx-loyalty-page')) customElements.define('rx-loyalty-page', RxLoyaltyPage)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-luxury-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rx-hero')) {
    customElements.define('rx-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-rx-hero-slide]')];
        this.dots = [...this.querySelectorAll('[data-rx-hero-dot]')];
        this.index = 0;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.show(Number(dot.dataset.rxHeroDot)));
        });

        this.show(0);

        if (
          this.dataset.autoplay === 'true' &&
          this.slides.length > 1 &&
          !matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          this.start();
        }
      }

      show(index) {
        this.index = index;

        this.slides.forEach((slide, position) => {
          slide.setAttribute('aria-hidden', String(position !== index));
        });

        this.dots.forEach((dot, position) => {
          if (position === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      start() {
        this.stop();
        const interval = Number(this.dataset.interval) || 6000;
        this.timer = setInterval(() => this.show((this.index + 1) % this.slides.length), interval);
      }

      stop() {
        clearInterval(this.timer);
      }

      disconnectedCallback() {
        this.stop();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-pdp-luxury-prototype"] && !Shopify.designMode) return;
  try {
    
  class LuxuryProduct extends HTMLElement {
    connectedCallback() {
      this.image = this.querySelector('.rx-luxury__hero-image')
      this.stage = this.querySelector('.rx-luxury__gallery-stage')
      this.index = this.querySelector('.rx-luxury__gallery-index')
      this.thumbnails = [...this.querySelectorAll('[data-gallery-image]')]
      this.thumbnails.forEach((button) => button.addEventListener('click', () => this.selectImage(button)))
      this.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => this.changeQuantity(button)))
      this.variantSelect = this.querySelector('[data-variant-select]')
      if (this.variantSelect) this.variantSelect.addEventListener('change', () => this.changeVariant())
      this.productForm = this.querySelector('.rx-luxury__form')
      this.handleProductSubmit = (event) => this.addToCart(event)
      if (this.productForm) this.productForm.addEventListener('submit', this.handleProductSubmit)
      this.onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > this.offsetTop + 420)
      window.addEventListener('scroll', this.onScroll, { passive: true })
      this.onScroll()
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll)
      if (this.productForm) this.productForm.removeEventListener('submit', this.handleProductSubmit)
    }

    async addToCart(event) {
      event.preventDefault()
      const button = this.querySelector('[data-add-button]')
      const status = this.querySelector('[data-form-status]')
      if (!this.productForm || !button || button.disabled || button.getAttribute('aria-busy') === 'true') return
      button.setAttribute('aria-busy', 'true')
      if (status) status.textContent = ''
      try {
        const formData = new FormData(this.productForm)
        formData.set('sections', 'cart-ajax')
        formData.set('sections_url', window.location.pathname)
        const shopRoot = window.Shopify?.routes?.root || '/'
        const variantId = Number(formData.get('id'))
        const requestedQuantity = Math.max(1, Number(formData.get('quantity') || 1))
        let quantityBefore = null
        try {
          const cartBeforeResponse = await fetch(`${shopRoot}cart.js`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          })
          if (cartBeforeResponse.ok) {
            const cartBefore = await cartBeforeResponse.json()
            const itemBefore = cartBefore.items.find((item) => item.variant_id === variantId)
            quantityBefore = itemBefore ? itemBefore.quantity : 0
          }
        } catch (_error) {
          quantityBefore = null
        }
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
        const responseText = await response.text()
        let data = null
        try {
          data = responseText ? JSON.parse(responseText) : null
        } catch (_error) {
          data = null
        }
        let addConfirmed = response.ok && data !== null
        if (!addConfirmed && quantityBefore !== null) {
          const cartAfterResponse = await fetch(`${shopRoot}cart.js`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          })
          if (cartAfterResponse.ok) {
            const cartAfter = await cartAfterResponse.json()
            const itemAfter = cartAfter.items.find((item) => item.variant_id === variantId)
            const quantityAfter = itemAfter ? itemAfter.quantity : 0
            addConfirmed = quantityAfter >= quantityBefore + requestedQuantity
          }
        }
        if (!addConfirmed) {
          const apiMessage = data?.description || data?.message
          const message = response.status === 422 ? (apiMessage || this.dataset.cartLimit) : (apiMessage || this.dataset.cartError)
          throw new Error(message)
        }
        if (!data?.sections?.['cart-ajax']) {
          const sectionsResponse = await fetch(`${shopRoot}?sections=cart-ajax`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          })
          if (sectionsResponse.ok) {
            const sections = await sectionsResponse.json()
            data = { ...(data || {}), sections }
          }
        }
        this.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: data, addToCartBtn: button }
        }))
      } catch (error) {
        const message = error.message || this.dataset.cartError
        if (status) status.textContent = message
        this.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          bubbles: true,
          detail: { errorMessage: message }
        }))
      } finally {
        button.removeAttribute('aria-busy')
      }
    }

    selectImage(button) {
      if (!this.image) return
      this.stage.classList.add('is-changing')
      this.thumbnails.forEach((thumbnail) => {
        const active = thumbnail === button
        thumbnail.classList.toggle('is-active', active)
        thumbnail.setAttribute('aria-pressed', active ? 'true' : 'false')
      })
      window.setTimeout(() => {
        this.image.src = button.dataset.galleryImage
        this.image.srcset = button.dataset.gallerySrcset
        this.image.alt = button.dataset.galleryAlt
        if (this.index) this.index.textContent = `${String(button.dataset.galleryIndex).padStart(2, '0')} / ${String(this.thumbnails.length).padStart(2, '0')}`
        this.stage.classList.remove('is-changing')
      }, 180)
    }

    changeQuantity(button) {
      const input = this.querySelector('input[name="quantity"]')
      if (!input) return
      input.value = Math.max(1, Number(input.value || 1) + Number(button.dataset.quantityChange))
    }

    changeVariant() {
      const option = this.variantSelect.selectedOptions[0]
      const price = this.querySelector('[data-product-price]')
      const button = this.querySelector('[data-add-button]')
      if (price) price.textContent = option.dataset.price
      if (button) button.disabled = option.dataset.available !== 'true'
      const url = new URL(window.location.href)
      url.searchParams.set('variant', option.value)
      window.history.replaceState({}, '', url)
    }
  }

  if (!customElements.get('luxury-product')) customElements.define('luxury-product', LuxuryProduct)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-salon-world"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rxsw]').forEach((root) => {
    const input = root.querySelector('[data-rxsw-search]');
    if (!input) return;
    const cards = Array.from(root.querySelectorAll('[data-rxsw-location]'));
    const empty = root.querySelector('[data-rxsw-empty]');
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const match = !query || card.dataset.search.includes(query);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
